import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmationModal = ({
    show,
    onHide,
    title = "Are you sure?",
    message = "Do you really want to perform this action?",
    confirmLabel = "Confirm",
    confirmVariant = "danger",
    cancelLabel = "Cancel",
    onConfirm,

}) => {
    return (
        <Modal className="customer-modal-without-header-footer crop-modal" centered show={show} onHide={onHide} backdrop="static" keyboard={false}>
            {/* <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header> */}
            <Modal.Body>
                <Modal.Title>{message}</Modal.Title>
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex justify-content-center w-100">
                    <Button variant={cancelLabel === "Cancel" ? "secondary" : "light"} className="crop-cancel-btn" onClick={onHide}>
                        {cancelLabel}
                    </Button>
                    <Button variant={confirmVariant} className='crop-save-btn' onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;
